import { render, staticRenderFns } from "./AddEditUser.vue?vue&type=template&id=5f12a5fe&scoped=true&"
import script from "./AddEditUser.vue?vue&type=script&lang=js&"
export * from "./AddEditUser.vue?vue&type=script&lang=js&"
import style0 from "./AddEditUser.vue?vue&type=style&index=0&id=5f12a5fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f12a5fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/ctorres/Documents/Dev/MCD/lsm-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCardTitle,VCheckbox,VDataTable,VForm,VSpacer,VSwitch,VTextField})
